import { render, staticRenderFns } from "./ModalEditarCamadasVinculadas.vue?vue&type=template&id=17796faf&lang=pug"
import script from "./ModalEditarCamadasVinculadas.vue?vue&type=script&lang=js"
export * from "./ModalEditarCamadasVinculadas.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarCamadasVinculadas.vue?vue&type=style&index=0&id=17796faf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports